import React from 'react';
import FormInput from 'components/Input/FormInput';

export const ArticleNumberField: React.FC = () => (
	<FormInput testId="ArticleNumberField" name="articleNumber" label="articleNumberLabel" disabled={true} />
);
